<template lang="pug">
include /../../s-pug/mixin-icon
.VideoEmbed(v-bind:class="{'Editor-embedWrap _radius _flex _flexDirection-column _overflowHidden': view.editable}")
   ._fluidIframeWrapper._ratio-16by9._h100._relative
      iframe._fluidIframe(v-bind:class="{'_mt0': view.editable}" :src="src.embedUrl")
      ._stretch._t-center(v-if="!src") 
         ._absoluteCenterXY Enter a YouTube or Vimeo video URL below
   div(v-if="view.editable")
      ._flex._mt05
         label._flex._w100._fs-075
            ._flex._noWrap._flex-alignItemsCenter._border._borderColor-grey-200._radius-left._pl075._pr05._bg-grey-050._cursor-pointer(v-tippy content="The URL for a YouTube or Vimeo video")
               | Video src
               .Editor-helpIcon._ml025: +icon({name: 'icon-help'})
            input.Input.Input--sm._radius-left0._borderLeft-none(@paste.stop type="text" :value="src.inputSrc" @input="onInput")
      ._t-right._mt05
         button.Btn.Btn--sm.Btn--white._ml-auto._fs-05(@click.stop.prevent="deleteVideo()") Remove video
</template>

<script>
import getVideoID from 'get-video-id'
export default {
   props: ['node', 'updateAttrs', 'view', 'getPos'],
   data() {
      return {
         src: this.node.attrs.src,
      }
   },
   methods: {
      onInput(e) {
         this.src.inputSrc = e.target.value
         this.src.embedUrl = this.createEmbedUrl(e.target.value)
         this.updateAttrs({ src: this.src })
      },
      deleteVideo() {
         // src: https://github.com/scrumpy/tiptap/issues/231
         // Do a Prosemirror transaction.
         let tr = this.view.state.tr
         let pos = this.getPos()
         tr.delete(pos, pos + this.node.nodeSize)
         this.view.dispatch(tr)
      },
      createEmbedUrl(src) {
         if (!src) {
            return
         }
         const { id, service } = getVideoID(src)
         if (service === 'youtube') {
            return `https://youtube.com/embed/${id}`
         } else if (service === 'vimeo') {
            return `https://player.vimeo.com/video/${id}`
         }
      },
   },
}
</script>
